"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Dashboard_1 = require("./Dashboard");
const Worksheet_1 = require("./Worksheet");
/**
 * Implementation of the dashboard objects - the zones in a dashboard.
 */
class DashboardObject {
    constructor(_dashboardObjectImpl) {
        this._dashboardObjectImpl = _dashboardObjectImpl;
    }
    get dashboard() {
        return new Dashboard_1.Dashboard(this._dashboardObjectImpl.dashboardImpl);
    }
    get type() {
        return this._dashboardObjectImpl.type;
    }
    get position() {
        return this._dashboardObjectImpl.position;
    }
    get size() {
        return this._dashboardObjectImpl.size;
    }
    get worksheet() {
        if (this._dashboardObjectImpl.worksheetImpl) {
            return new Worksheet_1.Worksheet(this._dashboardObjectImpl.worksheetImpl);
        }
        return undefined;
    }
    get name() {
        return this._dashboardObjectImpl.name;
    }
    get isFloating() {
        return this._dashboardObjectImpl.isFloating;
    }
    get isVisible() {
        return this._dashboardObjectImpl.isVisible;
    }
    get id() {
        return this._dashboardObjectImpl.id;
    }
    get fieldId() {
        return this._dashboardObjectImpl.fieldId;
    }
}
exports.DashboardObject = DashboardObject;
//# sourceMappingURL=DashboardObject.js.map